/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Changelist_UpdateInputs */

const id_components_changelist_update = /** @type {(inputs: Components_Changelist_UpdateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`perbarui`)
};

const ms_components_changelist_update = /** @type {(inputs: Components_Changelist_UpdateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`kemas kini`)
};

const da_components_changelist_update = /** @type {(inputs: Components_Changelist_UpdateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`opdater`)
};

const de_components_changelist_update = /** @type {(inputs: Components_Changelist_UpdateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`aktualisieren`)
};

const en_us2_components_changelist_update = /** @type {(inputs: Components_Changelist_UpdateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`update`)
};

const es_es2_components_changelist_update = /** @type {(inputs: Components_Changelist_UpdateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`actualización`)
};

const es_mx2_components_changelist_update = /** @type {(inputs: Components_Changelist_UpdateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`actualización`)
};

const fil_components_changelist_update = /** @type {(inputs: Components_Changelist_UpdateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`update`)
};

const fr_components_changelist_update = /** @type {(inputs: Components_Changelist_UpdateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mise à jour`)
};

const it_components_changelist_update = /** @type {(inputs: Components_Changelist_UpdateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`aggiornamento`)
};

const hu_components_changelist_update = /** @type {(inputs: Components_Changelist_UpdateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`frissítés`)
};

const nl_components_changelist_update = /** @type {(inputs: Components_Changelist_UpdateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`update`)
};

const no_components_changelist_update = /** @type {(inputs: Components_Changelist_UpdateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`oppdater`)
};

const pl_components_changelist_update = /** @type {(inputs: Components_Changelist_UpdateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`aktualizacja`)
};

const pt_br2_components_changelist_update = /** @type {(inputs: Components_Changelist_UpdateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update`)
};

const pt_components_changelist_update = /** @type {(inputs: Components_Changelist_UpdateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`atualização`)
};

const ro_components_changelist_update = /** @type {(inputs: Components_Changelist_UpdateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`actualizare`)
};

const fi_components_changelist_update = /** @type {(inputs: Components_Changelist_UpdateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`päivitys`)
};

const sv_components_changelist_update = /** @type {(inputs: Components_Changelist_UpdateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`uppdatering`)
};

const vi_components_changelist_update = /** @type {(inputs: Components_Changelist_UpdateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`cập nhật`)
};

const tr_components_changelist_update = /** @type {(inputs: Components_Changelist_UpdateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`güncelle`)
};

const cs_components_changelist_update = /** @type {(inputs: Components_Changelist_UpdateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`aktualizace`)
};

const bg_components_changelist_update = /** @type {(inputs: Components_Changelist_UpdateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`актуализация`)
};

const ru_components_changelist_update = /** @type {(inputs: Components_Changelist_UpdateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`обновление`)
};

const uk_components_changelist_update = /** @type {(inputs: Components_Changelist_UpdateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`оновлення`)
};

const ar_components_changelist_update = /** @type {(inputs: Components_Changelist_UpdateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تحديث`)
};

const hi_components_changelist_update = /** @type {(inputs: Components_Changelist_UpdateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अपडेट`)
};

const th_components_changelist_update = /** @type {(inputs: Components_Changelist_UpdateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`อัปเดต`)
};

const ja_components_changelist_update = /** @type {(inputs: Components_Changelist_UpdateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更新`)
};

const zh_cn2_components_changelist_update = /** @type {(inputs: Components_Changelist_UpdateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update`)
};

const zh_hant1_components_changelist_update = /** @type {(inputs: Components_Changelist_UpdateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update`)
};

const ko_components_changelist_update = /** @type {(inputs: Components_Changelist_UpdateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update`)
};

/**
* | output |
* | --- |
* | "update" |
*
* @param {Components_Changelist_UpdateInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_changelist_update = /** @type {((inputs?: Components_Changelist_UpdateInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Changelist_UpdateInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_changelist_update(inputs)
	if (locale === "ms") return ms_components_changelist_update(inputs)
	if (locale === "da") return da_components_changelist_update(inputs)
	if (locale === "de") return de_components_changelist_update(inputs)
	if (locale === "en-US") return en_us2_components_changelist_update(inputs)
	if (locale === "es-ES") return es_es2_components_changelist_update(inputs)
	if (locale === "es-MX") return es_mx2_components_changelist_update(inputs)
	if (locale === "fil") return fil_components_changelist_update(inputs)
	if (locale === "fr") return fr_components_changelist_update(inputs)
	if (locale === "it") return it_components_changelist_update(inputs)
	if (locale === "hu") return hu_components_changelist_update(inputs)
	if (locale === "nl") return nl_components_changelist_update(inputs)
	if (locale === "no") return no_components_changelist_update(inputs)
	if (locale === "pl") return pl_components_changelist_update(inputs)
	if (locale === "pt-BR") return pt_br2_components_changelist_update(inputs)
	if (locale === "pt") return pt_components_changelist_update(inputs)
	if (locale === "ro") return ro_components_changelist_update(inputs)
	if (locale === "fi") return fi_components_changelist_update(inputs)
	if (locale === "sv") return sv_components_changelist_update(inputs)
	if (locale === "vi") return vi_components_changelist_update(inputs)
	if (locale === "tr") return tr_components_changelist_update(inputs)
	if (locale === "cs") return cs_components_changelist_update(inputs)
	if (locale === "bg") return bg_components_changelist_update(inputs)
	if (locale === "ru") return ru_components_changelist_update(inputs)
	if (locale === "uk") return uk_components_changelist_update(inputs)
	if (locale === "ar") return ar_components_changelist_update(inputs)
	if (locale === "hi") return hi_components_changelist_update(inputs)
	if (locale === "th") return th_components_changelist_update(inputs)
	if (locale === "ja") return ja_components_changelist_update(inputs)
	if (locale === "zh-CN") return zh_cn2_components_changelist_update(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_changelist_update(inputs)
	return ko_components_changelist_update(inputs)
});
export { components_changelist_update as "components.changelist.update" }